<template>
  <section class="tw:flex tw:flex-col tw:w-full">
    <BaseCard>
      <SelectAccommodation
        v-if="!isSuggestionsLoading"
        :selectedValues="selectedCompetitors"
        :suggestions="suggestions"
        @onSelect="value => onSelect(value)"
      />
      <LaunchpadLoader class="tw:w-full tw:flex tw:items-center tw:justify-center" v-else />
      <Selected :selectedSuggestions="selectedCompetitors" @onSelect="value => onSelect(value)" />
      <div class="tw:flex tw:w-full tw:mt-4 tw:justify-end">
        <GhostButton
          v-if="isUpdateMode"
          @click="() => router.back()"
          @keydown.enter="() => router.back()"
          class="tw:mr-2"
        >
          {{ $t('assign_cancel_cta') }}
        </GhostButton>
        <GhostButton
          :disabled="selectedCompetitors.length === 0"
          @click="resetCompetitors"
          @keydown.enter="resetCompetitors"
          class="tw:mr-2"
        >
          {{ $t('ri_competitor_list_reset') }}
        </GhostButton>
        <MainButton
          class="tw:w-full tw:md:w-auto"
          :disabled="selectedCompetitors.length === 0"
          @click="value => saveCompetitors(value)"
          @keydown.enter="value => saveCompetitors(value)"
        >
          <span v-if="!buttonClicked">{{ isUpdateMode ? $t('save') : $t('setup_next') }}</span>
          <span v-if="buttonClicked">
            <SmallDotLoader color="#fff" />
          </span>
        </MainButton>
      </div>
    </BaseCard>
  </section>
</template>
<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSuggestions, useCompetitorsUpdateMutation, useCompetitors } from '@/components/rateInsights/queries'

import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import Selected from '@/components/rateInsights/onboarding/Selected.vue'
import SelectAccommodation from '@/components/rateInsights/onboarding/SelectAccommodation.vue'
import BaseCard from '@/components/dashboard/BaseCard.vue'

import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

const router = useRouter()
const route = useRoute()
const isUpdateMode = router.currentRoute?.value.query?.isUpdate
const { competitorsUpdate } = useCompetitorsUpdateMutation()
const { competitors } = useCompetitors(selectedAccommodationId)
const { isSuggestionsLoading, suggestions } = useSuggestions()
const competitorsArr = JSON.parse(JSON.stringify(competitors.value))
const selectedCompetitors = ref(isUpdateMode ? competitorsArr : [])
const buttonClicked = ref(false)

const resetCompetitors = () => {
  selectedCompetitors.value = []
}

const onSelect = option => {
  const allSuggestions = JSON.parse(JSON.stringify(selectedCompetitors.value))
  const index = allSuggestions.findIndex(item => item.id === option.id)
  if (index < 0) {
    allSuggestions.splice(0, 0, option)
    selectedCompetitors.value = allSuggestions
  } else {
    allSuggestions.splice(index, 1)
    selectedCompetitors.value = allSuggestions
  }
}

const saveCompetitors = () => {
  const selectedCompetitorsArr = selectedCompetitors.value.map(item => item.id)
  buttonClicked.value = true
  competitorsUpdate(
    { accommodationId: selectedAccommodationId.value, competitors: selectedCompetitorsArr },
    {
      onSuccess: data => {
        buttonClicked.value = false
        if (data.status >= 200 && data.status <= 210) {
          if (route.query?.from_insights === 'true' && route.query?.from_visitors_profile === 'true') {
            router.push({ name: 'visitors-profile-stay-duration' })
            appAnalytics.track(appAnalytics.events.SP_PLUS_FEATURE_ACTIVATED_FROM_INSIGHTS, {
              item_id: selectedAccommodationId.value,
              benefit_type: 'visitors_profile',
              benefit_status: 'active',
            })
          } else {
            if (route.query?.from_insights === 'true') {
              appAnalytics.track(appAnalytics.events.SP_PLUS_FEATURE_ACTIVATED_FROM_INSIGHTS, {
                item_id: selectedAccommodationId.value,
                benefit_type: 'rate_insights',
                benefit_status: 'active',
              })
            }
            router.push({ name: 'rate-insights-view' })
          }
        }
      },
      onError: () => (buttonClicked.value = false),
    }
  )
}
</script>
